<template>
  <div class="attendee-form">
  <!-- Header -->
  <Header
    class="header-lg"
    :HeaderTitle="IsEdit ? 'Edit attendee' : 'Add attendee'"
    :HeaderSubTitle="subtitle"
    :ShowBack="true"
    v-on:back="back"
  ></Header>

  <!-- Content -->
  <div class="content-wrap">
    <div class="add-attendee__title">Enter Attendee information</div>

    <form @submit.prevent="IsEdit ? edit() : add()">
      <!-- First name -->
      <div class="form-floating mb-4">
        <input
          type="text"
          class="form-control"
          id="firstName"
          autocomplete="given-name"
          placeholder="First name"
          v-model="firstName"
          required
          :class="{ 'input-required': error }"
        />
        <label for="firstName" class="form-label">First name*</label>
      </div>

      <!-- Last name -->
      <div class="form-floating mb-4">
        <input
          type="text"
          class="form-control"
          id="lastName"
          autocomplete="family-name"
          placeholder="Last
        name"
          v-model="lastName"
          required
          :class="{ 'input-required': error }"
        />
        <label for="lastName" class="form-label">Last name*</label>
      </div>

      <!-- Email -->
      <div class="form-floating mb-4">
        <input
          type="email"
          class="form-control"
          id="email"
          autocomplete="email"
          placeholder="Email"
          v-model="email"
        />
        <label for="email" class="form-label">Email</label>
      </div>

      <!-- Phone number -->
      <div class="form-floating mb-4">
        <input
          type="tel"
          class="form-control"
          id="phoneNumber"
          autocomplete="tel"
          placeholder="Phone number"
          v-model="phone"
        />
        <label for="phoneNumber" class="form-label">Phone number</label>
      </div>

      <!-- Country -->
      <div class="form-floating mb-4">
        <select v-model="country" class="form-select" id="floatingSelect">
          <option
            v-for="country in countries"
            v-bind:key="country"
            :value="country"
          >
            {{ country }}
          </option>
        </select>
        <label for="floatingSelect" class="form-label">Country</label>
      </div>

      <!-- Company -->
      <div class="form-floating mb-4">
        <input
          type="text"
          class="form-control"
          id="company"
          autocomplete="organization"
          placeholder="Company"
          v-model="company"
        />
        <label for="company" class="form-label">Company</label>
      </div>

      <!-- Job position -->
      <div class="form-floating mb-4">
        <input
          type="text"
          class="form-control"
          id="jobPosition"
          autocomplete="organization-title"
          placeholder="Job position"
          v-model="jobPosition"
        />
        <label for="jobPosition" class="form-label">Job position</label>
      </div>

      <div v-if="error" class="form-error">
        Please fill in the mandatory fields.
      </div>

      <div class="attendee-form__actions">
        <button @click="back" class="btn btn--default btn--sm" type="button">
          Cancel
        </button>
        <button
          class="btn btn--primary btn--sm ms-2"
          type="submit"
          v-if="IsEdit"
        >
          Save
        </button>
        <button
          class="btn btn--primary btn--sm ms-2"
          type="submit"
          v-else
        >
          Add
        </button>
      </div>
    </form>
  </div>
  </div>
</template>

<script>
import Header from "./HeaderComponent.vue";

export default {
  components: { Header },
  name: "AddAttendeeComponent",
  props: {
    EventId: String,
    ProgramId: String,
    ContactId: String,
    Attendee: Object,
    IsEdit: Boolean,
    IsProgram: Boolean,
  },
  data: () => ({
    firstName: String,
    lastName: String,
    email: String,
    company: String,
    jobPosition: String,
    country: String,
    phone: String,
    error: false,
  }),
  emits: ["closeAddAttendee"],
  methods: {
    back() {
      this.$emit("closeAddAttendee");
    },
    add() {
      this.validate();

      if (this.IsProgram) {
        fetch(
          process.env.VUE_APP_ROOT_API +
            "/v1/DataAPI/GetEventParticipantByEmail/json?" +
            new URLSearchParams({
              AuthToken: this.$store.getters.getAuthToken.token,
              EventID: this.EventId,
              Email: this.email,
            }),
          {
            method: "POST",
          }
        )
          .then((resp) => resp.json())
          .then((response) => {
            if (
              response.serviceStatus === "OK" &&
              response.data.Status === "OK"
            ) {
              if (
                Array.isArray(response.data.EventParticipants) &&
                response.data.EventParticipants.length
              )
                this.addToProgram(
                  response.data.EventParticipants[0].EventParticipantID,
                  response.data.EventParticipants[0].ContactID
                );
              else this.addVisitor(true);
            }
          })
          .catch((error) => {
            console.error("Error: ", error);
          });
      } else {
        this.addVisitor(false);
      }
    },
    addVisitor(shouldAddToProgram) {
      fetch(
        process.env.VUE_APP_ROOT_API +
          "/v1/DataAPI/AddVisitor/json?" +
          new URLSearchParams({
            AuthToken: this.$store.getters.getAuthToken.token,
            EventID: this.EventId,
            FirstName: this.firstName === undefined ? "" : this.firstName,
            LastName: this.lastName === undefined ? "" : this.lastName,
            Email: this.email === undefined ? "" : this.email,
            Company: this.company === undefined ? "" : this.company,
            Position: this.jobPosition === undefined ? "" : this.jobPosition,
            Country: this.country === undefined ? "" : this.country,
            Phone: this.phone === undefined ? "" : this.phone,
          }),
        {
          method: "POST",
        }
      )
        .then((resp) => resp.json())
        .then((response) => {
          if (
            response.serviceStatus === "OK" &&
            response.data.Status === "OK"
          ) {
            console.log("Visitor added");

            if (shouldAddToProgram)
              this.addToProgram(
                response.data.Visitor.EventParticipantID,
                response.data.Visitor.ContactID
              );
            else this.$emit("closeAddAttendee");
          }
        })
        .catch((error) => {
          console.error("Error: ", error);
        });
    },
    addToProgram(eventParticipantId, contactId) {
      fetch(
        process.env.VUE_APP_ROOT_API +
          "/v1/DataAPI/AddProgramParticipant/json?" +
          new URLSearchParams({
            AuthToken: this.$store.getters.getAuthToken.token,
            EventID: this.EventId,
            ContactID: contactId,
            ProgramID: this.ProgramId,
            EventParticipantID: eventParticipantId,
          }),
        {
          method: "POST",
        }
      )
        .then((resp) => resp.json())
        .then((response) => {
          if (
            response.serviceStatus === "OK" &&
            response.data.Status === "OK"
          ) {
            console.log("Added program participant");
            this.$emit("closeAddAttendee");
          }
        })
        .catch((error) => {
          console.error("Error: ", error);
        });
    },
    edit() {
      this.validate();

      fetch(
        process.env.VUE_APP_ROOT_API +
          "/v1/DataAPI/EditVisitor/json?" +
          new URLSearchParams({
            AuthToken: this.$store.getters.getAuthToken.token,
            EventID: this.EventId,
            ContactID: this.Attendee.ContactID,
            EventParticipantID: this.Attendee.EventParticipantID,
            FirstName: this.firstName === undefined ? "" : this.firstName,
            LastName: this.lastName === undefined ? "" : this.lastName,
            Email: this.email === undefined ? "" : this.email,
            Company: this.company === undefined ? "" : this.company,
            Position: this.jobPosition === undefined ? "" : this.jobPosition,
            Country: this.country === undefined ? "" : this.country,
            Phone: this.phone === undefined ? "" : this.phone,
          }),
        {
          method: "POST",
        }
      )
        .then((resp) => resp.json())
        .then((response) => {
          if (
            response.serviceStatus === "OK" &&
            response.data.Status === "OK"
          ) {
            console.log("Visitor edited");
            this.$emit("closeAddAttendee");
          }
        })
        .catch((error) => {
          console.error("Error: ", error);
        });
    },
    validate() {
      if (this.firstName === undefined || this.lastName === undefined) {
        this.error = true;
        return;
      }

      if (this.email === undefined)
        this.email = this.firstName + "." + this.lastName + "@meetpoint";
    },
  },
  computed: {
    isEvent() {
      if (!this.EventId == null) return false;
      else return true;
    },
    countries() {
      const countryList = require("country-list");
      return countryList.getNames().sort();
    },
    subtitle() {
      return this.IsProgram === true
        ? this.$store.getters.getProgramName
        : this.$store.getters.getEventName;
    },
  },
  mounted() {
    this.firstName = this.Attendee.FirstName;
    this.lastName = this.Attendee.LastName;
    this.email = this.Attendee.Email;
    this.company = this.Attendee.Company;
    this.jobPosition = this.Attendee.JobPosition;
    this.country = this.Attendee.Country;
    this.phone = this.Attendee.Phone;
  },
};
</script>
